import React, {useContext} from 'react'
import {
  CAvatar,
  CDropdown,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle
} from '@coreui/react-pro'
import {
  cilUser,
  cilAccountLogout
} from '@coreui/icons'
import CIcon from '@coreui/icons-react'

import avatar from '../../assets/images/avatar.jpg'
import {Context} from "../../context/AuthContext";

const AppHeaderDropdown = () => {

  const {handleLogout} = useContext(Context);

  const name = localStorage.getItem('name');

  const onClickLogout = () => {
    handleLogout();
  };

  return (
    <CDropdown variant="nav-item" alignment="end">
      <CDropdownToggle placement="bottom-end" className="py-0" caret={false} visible={false}>
        <b className="text-secondary">{name.split(" ")[0]}&nbsp;&nbsp;&nbsp;</b>
        <CAvatar src={avatar} size="md" />
      </CDropdownToggle>
      <CDropdownMenu className="pt-0">
        <CDropdownItem href="profile">
          <CIcon icon={cilUser} size="sm" className="c-header-nav-link" /> Profile
        </CDropdownItem>
        <CDropdownItem href="#" onClick={onClickLogout}>
          <CIcon icon={cilAccountLogout} size="sm" className="c-header-nav-link" /> Logout
        </CDropdownItem>
      </CDropdownMenu>
    </CDropdown>
  )
}

export default AppHeaderDropdown
